import { createContext } from 'react';

const EstruturaProdutoAppContext = createContext();

export default EstruturaProdutoAppContext;
